export default "__VITE_ASSET__B8eS6dXX__"